import React from 'react'
import { Platform, View, ViewStyle } from 'react-native'
import { TouchableOpacity } from 'react-native-gesture-handler'
import { SvgXml } from 'react-native-svg'
import { color } from '../../theme'
import { Medal } from '../medal'
import { RecallWheel } from '../recall-wheel'
import { Text } from '../text'
import { useTranslation } from 'react-i18next'

interface QuizHeaderProps {
  completedAttempts: number
  recall: number
  questionCount: number
  maxAttempts?: number | null
  medal: string | null | undefined
  inProgress: boolean
  style?: ViewStyle
  enterpriseTier?: boolean
  onPress?: any
  disabled?: any
}
export const QuizHeader = (props: QuizHeaderProps) => {
  const { disabled, onPress, enterpriseTier, completedAttempts, style, inProgress, medal, recall } =
    props

  const { t } = useTranslation()
  const levelTx = t(`Certifications.${medal?.toLowerCase()}`)

  return (
    <TouchableOpacity
      onPress={onPress}
      disabled={disabled}
      style={{
        ...PANEL,
        ...style,
        // @ts-ignore
        cursor: disabled ? 'default' : 'pointer',
      }}
    >
      {inProgress ? (
        <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          {Platform.OS === 'web' ? (
            <svg
              style={{ marginRight: 32 }}
              width="42"
              height="43"
              viewBox="0 0 42 43"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.9075 15.4625V27.5375C15.9075 28.1675 16.1787 28.64 16.7212 28.955C17.2637 29.27 17.7975 29.2525 18.3225 28.9025L27.825 22.8125C28.315 22.4975 28.56 22.06 28.56 21.5C28.56 20.94 28.315 20.5025 27.825 20.1875L18.3225 14.0975C17.7975 13.7475 17.2637 13.73 16.7212 14.045C16.1787 14.36 15.9075 14.8325 15.9075 15.4625ZM21 42.5C18.13 42.5 15.4175 41.9487 12.8625 40.8462C10.3075 39.7437 8.07625 38.2387 6.16875 36.3312C4.26125 34.4237 2.75625 32.1925 1.65375 29.6375C0.55125 27.0825 0 24.37 0 21.5C0 18.63 0.55125 15.9175 1.65375 13.3625C2.75625 10.8075 4.26125 8.57625 6.16875 6.66875C8.07625 4.76125 10.3075 3.25625 12.8625 2.15375C15.4175 1.05125 18.13 0.5 21 0.5C23.87 0.5 26.5825 1.05125 29.1375 2.15375C31.6925 3.25625 33.9237 4.76125 35.8312 6.66875C37.7387 8.57625 39.2437 10.8075 40.3462 13.3625C41.4487 15.9175 42 18.63 42 21.5C42 24.37 41.4487 27.0825 40.3462 29.6375C39.2437 32.1925 37.7387 34.4237 35.8312 36.3312C33.9237 38.2387 31.6925 39.7437 29.1375 40.8462C26.5825 41.9487 23.87 42.5 21 42.5Z"
                fill="#1B59F8"
              />
            </svg>
          ) : (
            <SvgXml
              style={{ marginRight: 32 }}
              xml={`<svg width="42" height="43" viewBox="0 0 42 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <path d="M15.9075 15.4625V27.5375C15.9075 28.1675 16.1787 28.64 16.7212 28.955C17.2637 29.27 17.7975 29.2525 18.3225 28.9025L27.825 22.8125C28.315 22.4975 28.56 22.06 28.56 21.5C28.56 20.94 28.315 20.5025 27.825 20.1875L18.3225 14.0975C17.7975 13.7475 17.2637 13.73 16.7212 14.045C16.1787 14.36 15.9075 14.8325 15.9075 15.4625ZM21 42.5C18.13 42.5 15.4175 41.9487 12.8625 40.8462C10.3075 39.7437 8.07625 38.2387 6.16875 36.3312C4.26125 34.4237 2.75625 32.1925 1.65375 29.6375C0.55125 27.0825 0 24.37 0 21.5C0 18.63 0.55125 15.9175 1.65375 13.3625C2.75625 10.8075 4.26125 8.57625 6.16875 6.66875C8.07625 4.76125 10.3075 3.25625 12.8625 2.15375C15.4175 1.05125 18.13 0.5 21 0.5C23.87 0.5 26.5825 1.05125 29.1375 2.15375C31.6925 3.25625 33.9237 4.76125 35.8312 6.66875C37.7387 8.57625 39.2437 10.8075 40.3462 13.3625C41.4487 15.9175 42 18.63 42 21.5C42 24.37 41.4487 27.0825 40.3462 29.6375C39.2437 32.1925 37.7387 34.4237 35.8312 36.3312C33.9237 38.2387 31.6925 39.7437 29.1375 40.8462C26.5825 41.9487 23.87 42.5 21 42.5Z" fill="#1B59F8"/>
                     </svg>
              `}
            />
          )}
          <View style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
            <Text style={{ marginBottom: 6 }} variant="titleEmphasized" tx="Quiz.inProgress" />
            <Text style={{ color: color.shade70 }} variant="body1" tx="Quiz.finishQuiz" />
          </View>
        </View>
      ) : completedAttempts === 0 ? (
        <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          {Platform.OS === 'web' ? (
            <svg
              style={{ marginRight: 32 }}
              width="42"
              height="43"
              viewBox="0 0 42 43"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.9075 15.4625V27.5375C15.9075 28.1675 16.1787 28.64 16.7212 28.955C17.2637 29.27 17.7975 29.2525 18.3225 28.9025L27.825 22.8125C28.315 22.4975 28.56 22.06 28.56 21.5C28.56 20.94 28.315 20.5025 27.825 20.1875L18.3225 14.0975C17.7975 13.7475 17.2637 13.73 16.7212 14.045C16.1787 14.36 15.9075 14.8325 15.9075 15.4625ZM21 42.5C18.13 42.5 15.4175 41.9487 12.8625 40.8462C10.3075 39.7437 8.07625 38.2387 6.16875 36.3312C4.26125 34.4237 2.75625 32.1925 1.65375 29.6375C0.55125 27.0825 0 24.37 0 21.5C0 18.63 0.55125 15.9175 1.65375 13.3625C2.75625 10.8075 4.26125 8.57625 6.16875 6.66875C8.07625 4.76125 10.3075 3.25625 12.8625 2.15375C15.4175 1.05125 18.13 0.5 21 0.5C23.87 0.5 26.5825 1.05125 29.1375 2.15375C31.6925 3.25625 33.9237 4.76125 35.8312 6.66875C37.7387 8.57625 39.2437 10.8075 40.3462 13.3625C41.4487 15.9175 42 18.63 42 21.5C42 24.37 41.4487 27.0825 40.3462 29.6375C39.2437 32.1925 37.7387 34.4237 35.8312 36.3312C33.9237 38.2387 31.6925 39.7437 29.1375 40.8462C26.5825 41.9487 23.87 42.5 21 42.5Z"
                fill="#1B59F8"
              />
            </svg>
          ) : (
            <SvgXml
              style={{ marginRight: 32 }}
              xml={`<svg width="42" height="43" viewBox="0 0 42 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.9075 15.4625V27.5375C15.9075 28.1675 16.1787 28.64 16.7212 28.955C17.2637 29.27 17.7975 29.2525 18.3225 28.9025L27.825 22.8125C28.315 22.4975 28.56 22.06 28.56 21.5C28.56 20.94 28.315 20.5025 27.825 20.1875L18.3225 14.0975C17.7975 13.7475 17.2637 13.73 16.7212 14.045C16.1787 14.36 15.9075 14.8325 15.9075 15.4625ZM21 42.5C18.13 42.5 15.4175 41.9487 12.8625 40.8462C10.3075 39.7437 8.07625 38.2387 6.16875 36.3312C4.26125 34.4237 2.75625 32.1925 1.65375 29.6375C0.55125 27.0825 0 24.37 0 21.5C0 18.63 0.55125 15.9175 1.65375 13.3625C2.75625 10.8075 4.26125 8.57625 6.16875 6.66875C8.07625 4.76125 10.3075 3.25625 12.8625 2.15375C15.4175 1.05125 18.13 0.5 21 0.5C23.87 0.5 26.5825 1.05125 29.1375 2.15375C31.6925 3.25625 33.9237 4.76125 35.8312 6.66875C37.7387 8.57625 39.2437 10.8075 40.3462 13.3625C41.4487 15.9175 42 18.63 42 21.5C42 24.37 41.4487 27.0825 40.3462 29.6375C39.2437 32.1925 37.7387 34.4237 35.8312 36.3312C33.9237 38.2387 31.6925 39.7437 29.1375 40.8462C26.5825 41.9487 23.87 42.5 21 42.5Z" fill="#1B59F8"/>
                        </svg>
          `}
            />
          )}
          <View style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
            <Text style={{ marginBottom: 6 }} variant="titleEmphasized" tx="Topic.notStarted" />
            <Text
              style={{ color: color.shade70 }}
              variant="body1"
              tx="Quiz.quizCompletionSubtitle"
            />
          </View>
        </View>
      ) : completedAttempts > 0 && medal !== null && enterpriseTier ? (
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            alignSelf: 'center',
          }}
        >
          <Medal
            style={{ marginRight: 32 }}
            hideRecall={medal == null}
            level={medal ?? null}
            recall={recall}
            size={42}
          />
          <View style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
            <Text style={{ marginBottom: 6 }} variant="titleEmphasized" tx="Quiz.complete" />
            <Text
              style={{ color: color.shade70 }}
              variant="body1"
              tx="Certifications.medalEarned"
              txOptions={{ medal: levelTx ?? 'No' }}
            />
          </View>
        </View>
      ) : completedAttempts > 0 ? (
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <RecallWheel
            variant="medium-large"
            circleColour="rgb(129, 52, 254)"
            iconColour="rgb(129, 52, 254)"
            strokeColor="rgb(216, 202, 254)"
            value={recall}
            icon="check"
            style={RECALL_WHEEL}
          />
          <View style={{ display: 'flex', flexDirection: 'column', marginLeft: 28 }}>
            <Text variant="titleEmphasized" tx="Quiz.complete" />
          </View>
        </View>
      ) : (
        <></>
      )}
    </TouchableOpacity>
  )
}

const PANEL_CONTENT: ViewStyle = {}
const PANEL: ViewStyle = {
  backgroundColor: '#F3F5FB',
  borderRadius: 16,
  paddingHorizontal: 20,
  paddingVertical: 22,
  marginHorizontal: 20,
  height: 83,
  justifyContent: 'center',
}
const RECALL_WHEEL: ViewStyle = { display: 'flex', flex: 0, flexShrink: 0, marginRight: 32 }
